<template>
  <div>
    <div
      data-v-2ed878fe=""
      class="listingpush"
      style="min-height: 190px"
    />
    <section class="cat_product_area">
      <div class="container conlist">
        <div class="flex-row-reverse">
          <!-- Ana İçerik Alanı -->
          <div
            class=""
            style="background: linear-gradient(to bottom, #fbf8f8, #ffffff)"
          >
            <div
              class=""
              style="
                transition:
                  background 0.3s,
                  border 0.3s,
                  border-radius 0.3s,
                  box-shadow 0.3s,
                  transform var(--e-transform-transition-duration, 0.4s);
              "
            >
              <div
                class="section-title section-title-dk-blue fl-wrap"
                style="width: 100%; position: relative; padding-bottom: 50px; text-align: center"
              >
                <h2><span>Shop</span></h2>
                <div class="section-subtitle">
                  Shop
                </div>
                <span class="section-separator section-separator-dk-blue" />
                <p>
                  Was Free, Now Free, Will Be Free (showing
                  {{ category ? ` from ${category}` : '' }}: {{ totalCount }} ads)
                </p>
              </div>
            </div>
          </div>
          <h2>Shop Ads</h2>
          <div
            v-if="loading"
            class="loading"
          >
            Loading...
          </div>
          <div
            v-if="error"
            class="error"
          >
            {{ error }}
          </div>
          <div class="sort-controls">
            <select v-model="sortOrder">
              <option value="newest">
                Newest First
              </option>
              <option value="oldest">
                Oldest First
              </option>
            </select>
          </div>
          <div
            id="petListingDiv"
            class="col-lg-12"
          />

          <div
            v-if="sortedServiceAds.length"
            class="latest_product_inner petnofilter"
          >
            <div
              id="bilgin"
              class="most_product_inner shop"
            >
              <!-- EBAY -->

              <div class="dik col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-6">
                <div class="pet-link">
                  <div class="card">
                    <div class="card-header justify-content-between">
                      <span
                        class="col"
                        style="font-size: 11.6px"
                      ><i>Colars </i></span>
                      <span
                        class="col boostabso"
                        style="font-size: 11.6px"
                      ><a class="animtext">
                        <i class="icon-diamond2" /> Boosted<i class="icon-diamond2" /></a></span>
                      <span
                        class="col text-muted"
                        style="font-size: 11.6px; padding-left: 0"
                      >
                        <i
                          class="fa fa-star"
                          style="color: orange"
                        />
                        <i
                          class="fa fa-star"
                          style="color: orange"
                        />
                        <i
                          class="fa fa-star"
                          style="color: orange"
                        />
                        <i
                          class="fa fa-star"
                          style="color: orange"
                        />
                        <i
                          class="fa fa-star"
                          style="color: orange"
                        />
                      </span>
                    </div>
                    <div class="hor-var">
                      <!-- Image -->
                      <div class="f_p_item resim_ana_d pricing-section">
                        <span class="resim_spa">
                          <div class="f_p_img resim_d">
                            <div class="cover-image">
                              <img
                                class="img-fluid resim"
                                src="../../public/images/set10-11.webp"
                                alt="Cover Image"
                              >
                            </div>
                          </div>
                        </span>
                      </div>
                      <!-- Ad body -->
                      <div class="card-body">
                        <h5 class="price_h5">
                          £35
                        </h5>
                        <h6 class="card-title">
                          Aha bura Title
                        </h6>
                        <!-- yatayda aktif -->
                        <p class="card-text">
                          Aha bura aciklama
                        </p>

                        <!-- <p class="card-text">All kittens’ vaccination done, Health check done, Litter trained, Worming done, They are ready to go. ✨ Blues …</p> -->
                      </div>
                      <!-- Ad footer -->
                      <div class="card-footer">
                        <div class="">
                          <a
                            style="font-size: 12px"
                            href="javascript:void(0)"
                          >Bilgin Shop </a>
                          <span
                            class="text-muted age text-end mb-0"
                            style="font-size: smaller; float: right"
                          >
                            <div class="amazon" /> </span><span
                            class="birth"
                            hidden=""
                          >2024-11-05</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Amazon -->
              <div class="dik col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-sm-6">
                <div class="pet-link">
                  <div class="card">
                    <div class="card-header justify-content-between">
                      <span
                        class="col"
                        style="font-size: 11.6px"
                      ><i>Colars </i></span>
                      <span
                        class="col boostabso"
                        style="font-size: 11.6px"
                      ><a class="animtext">
                        <i class="icon-diamond2" />Boosted<i class="icon-diamond2" /></a></span>
                      <span
                        class="col text-muted"
                        style="font-size: 11.6px; padding-left: 0"
                      >
                        <i
                          class="fa fa-star"
                          style="color: orange"
                        />
                        <i
                          class="fa fa-star"
                          style="color: orange"
                        />
                        <i
                          class="fa fa-star"
                          style="color: orange"
                        />
                        <i
                          class="fa fa-star"
                          style="color: orange"
                        />
                        <i
                          class="fa fa-star"
                          style="color: orange"
                        />
                      </span>
                    </div>
                    <div class="hor-var">
                      <!-- Image -->
                      <div class="f_p_item resim_ana_d pricing-section">
                        <span class="resim_spa">
                          <div class="f_p_img resim_d">
                            <div class="cover-image">
                              <img
                                class="img-fluid resim"
                                src="../../public/images/set10-11.webp"
                                alt="Cover Image"
                              >
                            </div>
                          </div>
                        </span>
                      </div>
                      <!-- Ad body -->
                      <div class="card-body">
                        <h5 class="price_h5">
                          £35
                        </h5>
                        <h6 class="card-title">
                          Aha bura Title
                        </h6>
                        <!-- yatayda aktif -->
                        <p class="card-text">
                          Aha bura aciklama
                        </p>

                        <!-- <p class="card-text">All kittens’ vaccination done, Health check done, Litter trained, Worming done, They are ready to go. ✨ Blues …</p> -->
                      </div>
                      <!-- Ad footer -->
                      <div class="card-footer">
                        <div class="">
                          <a
                            style="font-size: 12px"
                            href="javascript:void(0)"
                          >Bilgin Shop </a>
                          <span
                            class="text-muted age text-end mb-0"
                            style="font-size: smaller; float: right"
                          >
                            <svg
                              id="gh-logo"
                              xmlns="http://www.w3.org/2000/svg"
                              height="20"
                              viewBox="0 0 122 48.592"
                              aria-labelledby="ebayLogoTitle"
                            >
                              <title id="ebayLogoTitle">eBay Home</title>
                              <g>
                                <path
                                  fill="#F02D2D"
                                  d="M24.355 22.759c-.269-5.738-4.412-7.838-8.826-7.813-4.756.026-8.544 2.459-9.183 7.915zM6.234 26.93c.364 5.553 4.208 8.814 9.476 8.785 3.648-.021 6.885-1.524 7.952-4.763l6.306-.035c-1.187 6.568-8.151 8.834-14.145 8.866C4.911 39.844.043 33.865-.002 25.759c-.05-8.927 4.917-14.822 15.765-14.884 8.628-.048 14.978 4.433 15.033 14.291l.01 1.625z"
                                />
                                <path
                                  fill="#0968F6"
                                  d="M46.544 35.429c5.688-.032 9.543-4.148 9.508-10.32s-3.947-10.246-9.622-10.214-9.543 4.148-9.509 10.32 3.974 10.245 9.623 10.214zM30.652.029l6.116-.034.085 15.369c2.978-3.588 7.1-4.65 11.167-4.674 6.817-.037 14.412 4.518 14.468 14.454.045 8.29-5.941 14.407-14.422 14.454-4.463.026-8.624-1.545-11.218-4.681a33.237 33.237 0 01-.19 3.731l-5.994.034c.09-1.915.185-4.364.174-6.322z"
                                />
                                <path
                                  fill="#FFBD14"
                                  d="M77.282 25.724c-5.548.216-8.985 1.229-8.965 4.883.013 2.365 1.94 4.919 6.7 4.891 6.415-.035 9.826-3.556 9.794-9.289v-.637c-2.252.02-5.039.054-7.529.152zm13.683 7.506c.01 1.778.071 3.538.232 5.1l-5.688.032a33.381 33.381 0 01-.225-3.825c-3.052 3.8-6.708 4.909-11.783 4.938-7.532.042-11.585-3.915-11.611-8.518-.037-6.665 5.434-9.049 14.954-9.318 2.6-.072 5.529-.1 7.945-.116v-.637c-.026-4.463-2.9-6.285-7.854-6.257-3.68.021-6.368 1.561-6.653 4.2l-6.434.035c.645-6.566 7.53-8.269 13.595-8.3 7.263-.04 13.406 2.508 13.448 10.192z"
                                />
                                <path
                                  fill="#92C821"
                                  d="M91.939 19.852l-4.5-8.362 7.154-.04 10.589 20.922 10.328-21.02 6.486-.048-18.707 37.251-6.85.039 5.382-10.348-9.887-18.393"
                                />
                              </g>
                            </svg> </span><span
                            class="birth"
                            hidden=""
                          >2024-11-05</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else-if="loading"
            class="no-data"
          >
            <LoadingSpinner />
          </div>
          <div
            v-else
            class="no-listings"
          >
            <div class="empty-state">
              <i class="fas fa-search" />
              <h3>No listings found</h3>
              <p>There are currently no service listings available.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
  import { computed, ref, onMounted } from 'vue';
  import { useServiceStore } from '@/stores/serviceStore';
  import { storeToRefs } from 'pinia';
  import LoadingSpinner from '@/components/LoadingSpinner.vue';

  const serviceStore = useServiceStore();
  const { serviceAds, loading, error } = storeToRefs(serviceStore);
  
  onMounted(() => {
    serviceStore.fetchServiceAds();
  });

  const sortOrder = ref('newest');

  // Kategori ve toplam sayaç değişkenleri ekleyelim
  const category = ref(''); // Kategori, şimdilik boş olabilir

  // Toplam ilan sayısını hesaplayalım
  const totalCount = computed(() => {
    return serviceAds.value?.length || 0;
  });

  const parseDate = (dateValue) => {
    try {
      const date = dateValue?.toDate ? dateValue.toDate() : new Date(dateValue);
      return date.getTime();
    } catch {
      return 0;
    }
  };

  // Sıralı ilanlar
  const sortedServiceAds = computed(() => {
    if (!serviceAds.value) return [];

    return [...serviceAds.value].sort((a, b) => {
      const dateA = parseDate(a.createdAt);
      const dateB = parseDate(b.createdAt);
      return sortOrder.value === 'newest' ? dateB - dateA : dateA - dateB;
    });
  });
</script>

<style scoped>
  img {
    border: 0;
    -ms-interpolation-mode: bicubic;
    vertical-align: middle;
  }

  .img-fluid.resim {
    transition: 0.5s;
  }

  .img-fluid.resim:hover {
    transform: scale(1.3);
  }

  .clearfix:before,
  .clearfix:after,
  .container:before,
  .container:after,
  .container-fluid:before,
  .container-fluid:after,
  .row:before,
  .row:after {
    content: ' ';
    display: table;
  }

  .mrg-0 {
    margin: 0;
  }

  .no-list-style {
    list-style: none;
    margin: 0;
  }

  /*** Shop Start ***/
  .card-text {
    white-space: nowrap;
    /* Metni tek satırda tutar */
    overflow: hidden;
    /* Taşan metni gizler */
    text-overflow: ellipsis;
    /* Taşan metni "..." ile gösterir */
    width: 100%;
    /* Div'in genişliğini kaplamasını sağlar */
    display: block;
    /* Blok öğe olarak çalışmasını sağlar */
    height: unset;
    /* Yüksekliği ayarlar */
  }

  @media (min-width: 1024px) {
    .petnofilter .col-xxl-3 {
      width: 33.33333% !important;
    }
  }

  @media (min-width: 1200px) {
    .petnofilter .col-xxl-3 {
      width: 25% !important;
    }
  }

  @media (min-width: 1400px) {
    .petnofilter .col-xxl-3 {
      width: 20% !important;
    }
  }
  .card-footer {
    background-color: rgb(0 0 0 / 25%);
  }
  .amazon {
    background-position: -10px -90px;
    width: 76px;
    height: 27px;
    margin: 0 auto;
    background-image: url(https://m.media-amazon.com/images/G/02/gno/sprites/nav-sprite-global-1x-reorg-privacy._CB546380977_.png);
  }

  /*** Shop End ***/
</style>
